import { createDownloadableLink, formatUTCDate } from '@/helpers';
import { synthesize } from 'redux-dispatcher';

const mapDispatchToAC = {
  getDataSuccess: (data) => ({ data }),
  resetData: () => ({}),
  getData:
    (search, paging, sortOption = {}, filterOption = {}) =>
    async ({ Api, getState }) => {
      let pagingData = paging || getState().clinicAppt.paging;
      let { result, status } = await Api.post(`clinic-appointments/filter`, {
        pageIndex: pagingData.pageIndex,
        pageSize: pagingData.pageSize,
        search,
        ...filterOption,
        ...sortOption,
      });
      status === 200 && clinicApptDispatcher.getDataSuccess(result);
    },
  createClinicAppointment:
    (payload, onSuccess, onFailure) =>
    async ({ Api }) => {
      let { status } = await Api.post(`clinic-appointments`, payload);
      status === 200 ? onSuccess() : onFailure();
    },

  editClinicAppointment:
    (id, payload, onSuccess, onFailure) =>
    async ({ Api }) => {
      let { status } = await Api.put(`clinic-appointments/${id}`, payload);
      status === 200 ? onSuccess() : onFailure();
    },
  checkInClinicAppointment:
    (id, onSuccess) =>
    async ({ Api }) => {
      let { status } = await Api.put(`clinic-appointments/${id}/check-in`);
      status === 200 && onSuccess();
    },
  cancelClinicAppointment:
    (id, onSuccess) =>
    async ({ Api }) => {
      let { status } = await Api.put(`clinic-appointments/${id}/cancellation`);
      status === 200 && onSuccess();
    },
  getExportExcel:
    (params) =>
    async ({ Api }) => {
      let { result, status } = await Api.post(
        `clinic-appointments/exports/csv`,
        {
          ...params,
          fromDate: params?.fromDate
            ? formatUTCDate(params?.fromDate, { isStarOfDay: true })
            : undefined,
          endDate: params?.endDate
            ? formatUTCDate(params?.endDate, { isEndOfDay: true })
            : undefined,
        }
      );

      const fileName = `Clinic_Appointment_Report`;
      status === 200 && createDownloadableLink(result, fileName);
    },
  getDetailClinic:
    (id, onSuccess) =>
    async ({ Api }) => {
      const { status, result } = await Api.get(`clinic-appointments/${id}`);
      if (status === 200) {
        onSuccess && onSuccess(result);
      }
    },
};

const clinicApptDispatcher = synthesize('clinicAppt', mapDispatchToAC);
export default clinicApptDispatcher;
